import React from 'react'
import { Form, Input } from 'antd'
import { merchantsService } from '../../../../shared/api/services/merchants.service'

export const OwnerDetailsStep: React.FC = () => {
    const validateAvailability = async (value: string, type: string) => {
        if (!value) return Promise.resolve();
        try {
            const isAvailable = await merchantsService.checkAvailability(type, value);
            if (!isAvailable) {
                return Promise.reject(new Error(`This ${type} is already registered`));
            }
            return Promise.resolve();
        } catch (error) {
            console.error('Failed to validate availability:', error);
            return Promise.resolve(); // Fail validation open on API error or let it pass
        }
    }

    return (
        <div style={{ maxWidth: 600, margin: '0 auto' }}>
            <Form.Item
                label="Owner Name"
                name="owner_name"
                rules={[{ required: true, message: 'Please enter owner name' }]}
            >
                <Input placeholder="Enter owner's full name" />
            </Form.Item>

            <Form.Item
                label="Email Address"
                name="email"
                rules={[
                    { required: true, message: 'Please enter email address' },
                    { type: 'email', message: 'Please enter a valid email address' },
                    { validator: (_, value) => validateAvailability(value, 'email') }
                ]}
                validateTrigger="onBlur"
            >
                <Input placeholder="owner@example.com" />
            </Form.Item>

            <Form.Item
                label="Mobile Number"
                name="mobile"
                rules={[
                    { required: true, message: 'Please enter mobile number' },
                    { pattern: /^[6-9]\d{9}$/, message: 'Please enter a valid 10-digit Indian mobile number' },
                    { validator: (_, value) => validateAvailability(value, 'mobile') }
                ]}
                validateTrigger="onBlur"
            >
                <Input placeholder="9876543210" maxLength={10} />
            </Form.Item>
        </div>
    )
}
